import React from 'react';

import { cva } from "class-variance-authority";



const buttonVariants = cva(
    "inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 touch-target",
    {
        variants: {
            variant: {
                default: "bg-primary text-primary-foreground hover:bg-primary/90",
                destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
                outline: "border border-input hover:bg-accent hover:text-accent-foreground",
                secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
                ghost: "hover:bg-accent hover:text-accent-foreground",
                link: "text-primary underline-offset-4 hover:underline",
                success: "bg-success text-success-foreground hover:bg-success/90",
                warning: "bg-warning text-warning-foreground hover:bg-warning/90",
                danger: "bg-error text-error-foreground hover:bg-error/90",
            },
            size: {
                default: "h-12 px-4 py-2 md:h-10",
                sm: "h-10 rounded-xl px-3 md:h-9",
                lg: "h-12 rounded-xl px-6 md:px-8 md:h-11",
                icon: "h-12 w-12 md:h-10 md:w-10",
                xs: "h-10 rounded-xl px-2 text-xs md:h-8",
                xl: "h-14 rounded-xl px-8 text-base md:h-12 md:px-10",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
);

export default function Button({ children, variant = 'primary', size = 'md', className = '', ...props }) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-xl transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98] touch-target';
  
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary/90 active:bg-primary/80 focus:ring-primary',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80 active:bg-secondary/70 focus:ring-secondary',
    outline: 'border-2 border-primary text-primary hover:bg-primary/10 active:bg-primary/20 focus:ring-primary',
    ghost: 'text-primary hover:bg-primary/10 active:bg-primary/20 focus:ring-primary',
    destructive: 'bg-destructive text-white hover:bg-destructive/90 active:bg-destructive/80 focus:ring-destructive',
  };
  
  const sizes = {
    sm: 'px-3 py-2 text-sm min-h-[44px]',
    md: 'px-4 py-2.5 text-sm sm:text-base min-h-[48px]',
    lg: 'px-6 py-3 text-base sm:text-lg min-h-[48px]',
  };
  
  return (
    <button
      className={`${baseStyles} ${variants?.[variant]} ${sizes?.[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}